<mat-tab-group [selectedIndex]="0">
  <mat-tab *ngFor="let bundeslandName of bundeslaenderTabs" [label]="bundeslandName">
    <h3 class="heading">Biowetter Deutschland</h3>
    <app-biowetter-zone
      *ngFor="let biowetter of getBiowetterForBundesland(bundeslandName)"
      [biowetter]="biowetter">
    </app-biowetter-zone>
  </mat-tab>
</mat-tab-group>
